import { useAuthenticatedSubmit } from '@/modules/submissions/presentation/hooks/use-authenticated-submit';
import { useTenant } from '@/modules/tenant/presentation/hooks/use-tenant';
import { SimuladoDraftStore } from '../../data/datasources/simulado-draft.store';

/**
 * O envio do ensaio. Sem sessão, o diálogo começa no **cadastro** — quem faz
 * o ensaio antes da prova, em geral, ainda não tem conta —, com "já tenho
 * conta" a um clique.
 *
 * Depois do envio o rascunho do navegador sai: o ensaio passou a morar no
 * servidor, e é de lá que o painel o lê.
 */
export function useFinishEnsaio(onDone: () => void) {
  const { id, edition } = useTenant();

  return useAuthenticatedSubmit({
    kind: 'ensaio',
    reason: 'ensaio',
    firstView: { kind: 'sign-up' },
    onDone: () => {
      new SimuladoDraftStore(id, edition.year).clear();
      onDone();
    },
  });
}
